// Canal direto com o fundador (WhatsApp de suporte). Usado pelo botão
// "Fale com o fundador" do DashboardLayout e pelo modal de boas-vindas.
// O mesmo número vai no e-mail de boas-vindas (EmailService, no backend).

export const FOUNDER_WHATSAPP_NUMBER = "5582996507466";

/**
 * Link wa.me com a mensagem já preenchida: quem é a pessoa e em que tela
 * ela estava, para não precisar perguntar.
 */
export function buildFounderWhatsAppUrl({ name, email, screen }) {
  const who = [name, email ? `(${email})` : ""].filter(Boolean).join(" ");
  const text = `Olá Edson, sou ${who || "usuário do Litterae"}, estou na tela ${screen} e...`;

  return `https://wa.me/${FOUNDER_WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}
